// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        document.querySelector('.main-menu__close').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.main-menu').classList.remove('-isActive');
            document.querySelector('.header').classList.remove('-isActive');
        });

        document.querySelector('.header__btn').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.main-menu').classList.add('-isActive');
            document.querySelector('.header').classList.add('-isActive');
        });

        document.querySelectorAll('.main-menu .menu-item-has-children > .expand').forEach($e => {
            $e.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                toggleExpansion(e.target.parentNode);
            });

            $e.addEventListener('keydown', (e) => {
                if (e.keyCode === 13 || e.keyCode == 32) {
                    e.preventDefault();
                    e.stopPropagation();

                    toggleExpansion(e.target.parentNode);
                }
            });
        });

        function toggleExpansion(target) {
            var expanded = document.querySelector('.-isExpanded');
            if (expanded && !target.classList.contains('-isExpanded')) {
                expanded.classList.remove('-isExpanded');
            }

            target.classList.toggle('-isExpanded');
        }

        $('.wp-block-cb-carousel').slick();

        var $player = document.querySelector('.hero__video iframe');
        var $pause = document.querySelector('.hero__pause');
        var isPlaying = true;

        if ( $player && $pause ) {
            $player.dataset.originalSrc = $player.src;

            $pause.addEventListener('click', function(e){
                if ( isPlaying ) {
                    $player.src = $player.dataset.originalSrc.replace("autoplay=1", "autoplay=0");
                    $player.style.display = "none";
                    $pause.querySelector('span').innerHTML = 'Play';
                }
                else {
                    $player.src = $player.dataset.originalSrc;
                    $pause.querySelector('span').innerHTML = 'Pause';
                    setTimeout(()=>$player.style.display = "block", 1000);
                }
                $pause.querySelector('.hero__pause-pause').classList.toggle('show');
                $pause.querySelector('.hero__pause-play').classList.toggle('show');

                isPlaying = !isPlaying;
            });
        }

    }, false);

})(jQuery);